export default __webpack_public_path__ + "static/media/RWA.84ccd2d1.svg";